(function(){
  'use strict';

  // ── MOBILE MENU ──
  var burger = document.getElementById('Burger');
  var mobileMenu = document.getElementById('MobileMenu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function(){
      mobileMenu.classList.toggle('open');
    });
  }

  // ── AJAX ADD TO CART (from product cards) ──
  function updateCartCount(){
    fetch(window.MGM.routes.cart + '.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var el = document.getElementById('CartCount');
        if (el) el.textContent = cart.item_count;
      }).catch(function(){});
  }

  document.querySelectorAll('form.ajax-add').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Añadiendo...'; }
      var formData = new FormData(form);
      fetch(window.MGM.routes.cart_add, {
        method:'POST',
        headers:{'Accept':'application/json'},
        body: formData
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        updateCartCount();
        if (btn) {
          btn.innerHTML = '✓ Añadido';
          setTimeout(function(){ btn.disabled = false; btn.innerHTML = original; }, 1400);
        }
      })
      .catch(function(){
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
      });
    });
  });

  // ── PRODUCT GALLERY THUMBS ──
  var mainImg = document.getElementById('PdMainImg');
  document.querySelectorAll('.pd-thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var src = thumb.getAttribute('data-img');
      if (mainImg && src) mainImg.src = src;
      document.querySelectorAll('.pd-thumb').forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // ── QUANTITY SELECTOR (product page) ──
  var qtyInput = document.getElementById('Qty');
  document.querySelectorAll('[data-qty]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (!qtyInput) return;
      var delta = parseInt(btn.getAttribute('data-qty'), 10);
      var val = parseInt(qtyInput.value, 10) || 1;
      val += delta;
      if (val < 1) val = 1;
      qtyInput.value = val;
    });
  });

})();

/* ── VARIANT MATRIX (selector de pesos múltiple) ── */
(function(){
  'use strict';
  var matrix = document.getElementById('VariantMatrix');
  if (!matrix) return;

  var mode = matrix.getAttribute('data-mode'); // 'cart' o 'wa'
  var mainImg = document.getElementById('PdMainImg');
  var summary = document.getElementById('VmSummary');
  var rows = Array.prototype.slice.call(matrix.querySelectorAll('.vm-row'));

  function imgFor(row){ return row.getAttribute('data-img'); }

  // Cambiar imagen al pulsar/enfocar una fila de peso
  rows.forEach(function(row){
    function activate(){
      var img = imgFor(row);
      if (img && mainImg) mainImg.src = img;
      rows.forEach(function(r){ r.classList.remove('active'); });
      row.classList.add('active');
    }
    row.addEventListener('click', function(e){
      if (e.target.closest('.vm-qty')) return; // no robar foco a los botones
      activate();
    });
    var input = row.querySelector('[data-vqty]');
    if (input) input.addEventListener('focus', activate);

    // Botones +/- de cada peso
    row.querySelectorAll('[data-vstep]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var delta = parseInt(btn.getAttribute('data-vstep'),10);
        var val = parseInt(input.value,10) || 0;
        val += delta; if (val < 0) val = 0;
        input.value = val;
        activate();
        updateSummary();
      });
    });
    if (input) input.addEventListener('input', updateSummary);
  });

  function selection(){
    var items = [];
    rows.forEach(function(row){
      var qty = parseInt(row.querySelector('[data-vqty]').value,10) || 0;
      if (qty > 0){
        items.push({
          id: row.getAttribute('data-vid'),
          qty: qty,
          name: row.querySelector('.vm-name').textContent.trim()
        });
      }
    });
    return items;
  }

  function updateSummary(){
    var items = selection();
    if (!items.length){
      summary.innerHTML = 'Aún no has seleccionado ninguna unidad.';
      return;
    }
    var total = items.reduce(function(s,i){ return s+i.qty; },0);
    var parts = items.map(function(i){ return '<b>'+i.qty+'×</b> '+i.name; });
    summary.innerHTML = parts.join(' · ') + ' &nbsp;—&nbsp; <span class="vm-total">'+total+' unidades</span>';
  }

  // ── Añadir selección al carrito (cuando hay precio) ──
  var addCartBtn = document.getElementById('VmAddCart');
  if (addCartBtn){
    addCartBtn.addEventListener('click', function(){
      var items = selection();
      if (!items.length){ summary.innerHTML = '<b style="color:var(--gold)">Elige al menos una unidad.</b>'; return; }
      addCartBtn.disabled = true;
      var original = addCartBtn.innerHTML;
      addCartBtn.innerHTML = 'Añadiendo...';
      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items: items.map(function(i){ return {id: parseInt(i.id,10), quantity: i.qty}; }) })
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        return fetch('/cart.js').then(function(r){return r.json();});
      })
      .then(function(cart){
        var el = document.getElementById('CartCount');
        if (el) el.textContent = cart.item_count;
        addCartBtn.innerHTML = '✓ Añadido al pedido';
        rows.forEach(function(r){ r.querySelector('[data-vqty]').value = 0; });
        updateSummary();
        setTimeout(function(){ addCartBtn.disabled=false; addCartBtn.innerHTML=original; }, 1600);
      })
      .catch(function(){ addCartBtn.disabled=false; addCartBtn.innerHTML=original; });
    });
  }

  // ── Pedir presupuesto por WhatsApp (cuando no hay precio) ──
  var addWaBtn = document.getElementById('VmAddWa');
  if (addWaBtn){
    addWaBtn.addEventListener('click', function(){
      var items = selection();
      if (!items.length){ summary.innerHTML = '<b style="color:var(--gold)">Elige al menos una unidad.</b>'; return; }
      var lines = items.map(function(i){ return i.qty+'x '+i.name; });
      var msg = 'Hola, me interesa '+window.MGM_PRODUCT.title+':\n'+lines.join('\n')+'\n\n¿Podéis darme precio y disponibilidad?';
      window.open('https://wa.me/'+window.MGM_PRODUCT.wa+'?text='+encodeURIComponent(msg), '_blank');
    });
  }
})();
